// extracted by mini-css-extract-plugin
module.exports = {"root":"IconEmailAttention_root__p25jA","marketplaceStroke":"IconEmailAttention_marketplaceStroke__2PR7r","attentionStroke":"IconEmailAttention_attentionStroke__1rmj3"};